import { t } from '@avalara/bat-apps-shared/i18n';
import { Fragment } from 'react';
import styled from 'styled-components';

import CybersourcePaymentPage from '../cybersource-payment';
import Accordion from '../shared/accordion';
import ConnectorSelect from '../shared/connectors/connector-select';
import CreateAccountForm from '../shared/create-account-form';

import { FieldDefaults } from '../styled/components/sign-up';

import BuyButton from './buy-button';
const SignUpForm = styled.div`
  i, b {
    font-size: 12px;
  }

  ${FieldDefaults}
`;

type AccountAndPaymentAccordionProps = {
  createAccountOpen: boolean;
  isLoggedIn: boolean;
  onAccountOrPaymentAccordionToggle: () => void;
  paymentView: string;
  accountTitleText?: string;
  hidePaymentPage?: boolean;
  showConnectors?: boolean;
};

const AccountAndPaymentAccordions = ({
  createAccountOpen,
  isLoggedIn,
  onAccountOrPaymentAccordionToggle,
  paymentView,
  accountTitleText,
  hidePaymentPage,
  showConnectors,
}: AccountAndPaymentAccordionProps) => (
  <Fragment>
    <div className='accordion-container'>
      {!isLoggedIn && (
        <Accordion show={createAccountOpen} onToggle={onAccountOrPaymentAccordionToggle} title={accountTitleText || ''}>
          <SignUpForm>
            <CreateAccountForm />
            {showConnectors && <ConnectorSelect />}
          </SignUpForm>
        </Accordion>
      )}
      {!hidePaymentPage ? (
        <Accordion
          show={!createAccountOpen}
          onToggle={onAccountOrPaymentAccordionToggle}
          title={t('client.accessibility.payment-method')}
        >
          <CybersourcePaymentPage paymentView={paymentView} />
        </Accordion>
      ) : (
        <BuyButton showConnectors={showConnectors} />
      )}
    </div>
  </Fragment>
);

export default AccountAndPaymentAccordions;
